function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect, forwardRef } from 'react';
import { Times } from '@resultadosdigitais/tangram-react-icons';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ScopedCssBaseline, FocusStyle } from '../StyleBase';
import IconButton from '../IconButton';
import { sizeStyle, kindStyle } from './constant';
import { KINDS, SIZES } from '../helper';

var resolveKindStyle = function resolveKindStyle(kind, removable) {
  if (removable) return kindStyle["default"];
  return kindStyle[kind] ? kindStyle[kind] : kindStyle["default"];
};

var resolveSizeStyle = function resolveSizeStyle(size) {
  if (!size) return sizeStyle.md;
  return sizeStyle[size] ? sizeStyle[size] : sizeStyle.md;
};

var Root = styled.span.withConfig({
  displayName: "Tag__Root",
  componentId: "sc-12g1lok-0"
})(["", " box-sizing:content-box;border-radius:var(--border-radius-rounded);padding:0 var(--size-spacing-02);width:max-content;display:inline-flex;align-items:center;cursor:default;", " ", " ", ""], ScopedCssBaseline, function (_ref2) {
  var tagKind = _ref2.tagKind,
      removable = _ref2.removable;

  var _resolveKindStyle = resolveKindStyle(tagKind, removable),
      background = _resolveKindStyle.background,
      color = _resolveKindStyle.color,
      fill = _resolveKindStyle.fill;

  return css(["text-transform:", ";background-color:", ";color:", ";svg{fill:", ";}"], tagKind !== KINDS.DEFAULT && !removable ? 'uppercase' : 'none', background, color, fill);
}, function (_ref3) {
  var size = _ref3.size;

  var _resolveSizeStyle = resolveSizeStyle(size),
      height = _resolveSizeStyle.height,
      font = _resolveSizeStyle.font,
      innerSpacing = _resolveSizeStyle.innerSpacing;

  return css(["height:", ";font:", ";svg{margin-right:", ";}"], height, font, innerSpacing);
}, function (_ref4) {
  var removable = _ref4.removable;
  return removable && css(["", " cursor:pointer;&:hover,&:active,&:focus-within{background-color:var(--color-gray-20);}"], FocusStyle);
});
var CloseButton = styled(IconButton).withConfig({
  displayName: "Tag__CloseButton",
  componentId: "sc-12g1lok-1"
})(["padding:0;background-color:transparent;outline:none;height:auto;svg{fill:var(--color-gray-60);}&:hover:not([disabled]){background-color:transparent;svg{fill:var(--color-gray-80);}}&:focus-within{outline:none;border-radius:0;box-shadow:none;}", ""], function (_ref5) {
  var size = _ref5.size;

  var _resolveSizeStyle2 = resolveSizeStyle(size),
      innerSpacing = _resolveSizeStyle2.innerSpacing;

  return css(["margin-left:", ";"], innerSpacing);
});
var Tag =
/*#__PURE__*/
forwardRef(function (_ref, ref) {
  var kind = _ref.kind,
      size = _ref.size,
      children = _ref.children,
      startIcon = _ref.startIcon,
      removable = _ref.removable,
      onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, ["kind", "size", "children", "startIcon", "removable", "onClick"]);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _resolveSizeStyle3 = resolveSizeStyle(size),
      iconSize = _resolveSizeStyle3.iconSize;

  var getResizedIcon = function getResizedIcon() {
    return (
      /*#__PURE__*/
      React.isValidElement(startIcon) &&
      /*#__PURE__*/
      React.cloneElement(startIcon, _extends({}, startIcon.props, {
        size: iconSize
      }))
    );
  };

  useEffect(function () {
    if (kind !== 'default' && typeof children === 'string' && children.split(' ').length > 2) {
      console.warn('Is not recommended to use more thant two words');
    }

    return function () {
      return onClick();
    };
  });
  return visible &&
  /*#__PURE__*/
  React.createElement(Root, _extends({
    tagKind: kind,
    size: size,
    removable: removable
  }, rest, {
    ref: ref
  }), startIcon && getResizedIcon(), children, removable &&
  /*#__PURE__*/
  React.createElement(CloseButton, {
    size: size,
    kind: IconButton.kinds.tertiary,
    onClick: function onClick() {
      setVisible(false);
    }
  },
  /*#__PURE__*/
  React.createElement(Times, {
    size: iconSize,
    title: "Remove tag",
    titleId: "idIconCloseTag"
  })));
});
Tag.displayName = 'Tag';
Tag.kinds = {
  "default": KINDS.DEFAULT,
  primary: KINDS.PRIMARY,
  success: KINDS.SUCCESS,
  danger: KINDS.DANGER,
  warning: KINDS.WARNING,
  help: KINDS.HELP
};
Tag.sizes = {
  md: SIZES.MD,
  lg: SIZES.LG,
  xl: SIZES.XL
};
Tag.defaultProps = {
  kind: Tag.kinds["default"],
  startIcon: null,
  removable: false,
  onClick: function onClick() {},
  as: 'span',
  forwardedAs: undefined,
  size: Tag.sizes.MD
};
process.env.NODE_ENV !== "production" ? Tag.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node]).isRequired,

  /**
   * Set a type tag
   */
  kind: PropTypes.oneOf([Tag.kinds["default"], Tag.kinds.primary, Tag.kinds.success, Tag.kinds.warning, Tag.kinds.danger, Tag.kinds.help]),

  /**
   * Set icon on start
   */
  startIcon: PropTypes.node,

  /**
   * Set a type removable tag
   */
  removable: PropTypes.bool,

  /**
   * Set a function to close tag with button
   */
  onClick: PropTypes.func,

  /**
   * Set element type to be rendered for this component. By default it will be render a `<p>` element.
   */
  as: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   * Set element type with new style to be rendered for this component. By default it will be render a `p` element.
   */
  forwardedAs: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),

  /**
   * set the tag's size
   */
  size: PropTypes.oneOf([Tag.sizes.md, Tag.sizes.lg, Tag.sizes.xl])
} : void 0;
export default Tag;